import type { FC } from "react";
import { defaultColor } from "../constants";
import type { IconProps } from "./types";
export const Library: FC<IconProps> = ({
  color = defaultColor,
  height = 24,
}) => (
  <svg
    width="25"
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1634_6425"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="24"
    >
      <rect x="0.5" width="24" height="24" fill={color} />
    </mask>
    <g mask="url(#mask0_1634_6425)">
      <path
        d="M12.5 19.649C12.35 19.649 12.2042 19.6323 12.0625 19.599C11.9208 19.5656 11.7917 19.5073 11.675 19.424C10.975 18.974 10.2333 18.624 9.45 18.374C8.66667 18.124 7.85 17.999 7 17.999C6.3 17.999 5.6125 18.0906 4.9375 18.274C4.2625 18.4573 3.61667 18.7156 3 19.049C2.65 19.2323 2.3125 19.224 1.9875 19.024C1.6625 18.824 1.5 18.5323 1.5 18.149V6.09896C1.5 5.91562 1.54583 5.74062 1.6375 5.57396C1.72917 5.40729 1.86667 5.28229 2.05 5.19896C2.81667 4.79896 3.61667 4.49896 4.45 4.29896C5.28333 4.09896 6.13333 3.99896 7 3.99896C7.96667 3.99896 8.9125 4.12396 9.8375 4.37396C10.7625 4.62396 11.65 4.99896 12.5 5.49896V17.499C13.35 16.9656 14.2417 16.5656 15.175 16.299C16.1083 16.0323 17.05 15.899 18 15.899C18.5833 15.899 19.1542 15.949 19.7125 16.049C20.2708 16.149 20.8333 16.2906 21.4 16.474V4.54896C21.6833 4.63229 21.95 4.72812 22.2 4.83646C22.45 4.94479 22.7 5.06562 22.95 5.19896C23.1333 5.28229 23.2708 5.40729 23.3625 5.57396C23.4542 5.74062 23.5 5.91562 23.5 6.09896V18.149C23.5 18.5323 23.3375 18.824 23.0125 19.024C22.6875 19.224 22.35 19.2323 22 19.049C21.3833 18.7156 20.7375 18.4573 20.0625 18.274C19.3875 18.0906 18.7 17.999 18 17.999C17.15 17.999 16.3333 18.124 15.55 18.374C14.7667 18.624 14.025 18.974 13.325 19.424C13.2083 19.5073 13.0792 19.5656 12.9375 19.599C12.7958 19.6323 12.65 19.649 12.5 19.649ZM15.525 13.824C15.3417 13.9906 15.1417 14.024 14.925 13.924C14.7083 13.824 14.6 13.6573 14.6 13.424V5.42396C14.6 5.37396 14.65 5.24896 14.75 5.04896L18.35 1.44896C18.5333 1.26562 18.7375 1.21979 18.9625 1.31146C19.1875 1.40313 19.3 1.57396 19.3 1.82396V10.199C19.3 10.2156 19.2417 10.3573 19.125 10.624L15.525 13.824Z"
        fill={color}
      />
    </g>
  </svg>
);
